var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrScanFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 272,
    viewBox: "0 0 327 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8047 35.1806V26.0945C50.8047 21.0718 54.8765 17 59.8992 17H73.0965",
    stroke: "#FFB01D",
    strokeWidth: 2.48033,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8047 236.819V245.905C50.8047 250.928 54.8765 255 59.8992 255H73.0965",
    stroke: "#FFB01D",
    strokeWidth: 2.48033,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.199 236.819V245.905C276.199 250.928 272.127 255 267.105 255H253.907",
    stroke: "#FFB01D",
    strokeWidth: 2.48033,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.266 35.1806V26.0945C275.266 21.0718 271.194 17 266.171 17H252.974",
    stroke: "#FFB01D",
    strokeWidth: 2.48033,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.783 102.154H159.758V109.692H182.322V87.1282H174.783V102.154Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.757 94.667H152.219V102.206H159.757V94.667Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.167 102.154H114.629V109.692H122.167V102.154Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.502 102.154H234.938V109.692H257.502V102.154Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0386 109.692H69.5V117.231H77.0386V109.692Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.191 109.692H152.216V102.154H137.191V79.5896H129.652V117.179H137.191V109.692Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.373 117.179H219.912V102.154H197.348V109.692H212.373V117.179Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.988 109.692H227.449V117.231H234.988V109.692Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.242 124.718V117.179H159.756V109.692H152.217V117.179H137.191V124.718H152.217V132.257H159.756V124.718H167.242Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.476 124.718V132.256H250.015V139.743H257.502V117.179H234.938V124.718H242.476Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.628 124.718H129.654V117.179H99.6027V109.692H107.09V102.154H84.5255V109.692H92.0641V124.718H84.5255V117.179H77.0386V124.718H69.5V169.846H77.0386V139.743H84.5255V132.257H92.0641V139.743H129.654V132.257H114.628V124.718Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.191 124.718H129.652V132.257H137.191V124.718Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.476 132.257H234.938V139.795H242.476V132.257Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.448 147.282H219.91V139.743H227.448V132.205H219.91V124.718H212.423V132.205H204.884V117.179H197.346V109.641H182.423V117.179H189.962V132.205H197.449V139.743H182.423V117.179H174.936V124.718H167.398V132.205H159.859V139.743H174.936V147.282H204.988V139.743H212.526V147.282H204.988V154.769H242.577V162.307H197.449V154.769H189.962V177.333H182.423V184.923H174.936V177.333H167.398V199.897H174.936V192.41H182.423V199.897H204.988V214.974H212.526V230H220.013V207.436H212.526V199.897H220.013V207.436H227.552V169.846H235.09V184.923H242.577V192.462H250.116V184.923H257.655V169.846H250.116V177.333H242.577V169.846H250.116V162.307H257.655V147.282H235.09V139.743H227.552L227.448 147.282ZM219.91 192.41H197.346V169.846H219.91V192.41Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.269 139.743H144.73V154.769H152.269V139.743Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0659 147.282H84.5273V169.846H92.0659V147.282Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.678 162.308V154.821H137.191V147.282H99.6016V162.308H107.089V154.821H122.166V162.308H114.627V169.846H129.653V162.308H144.678Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.191 169.846H129.652V177.385H137.191V169.846Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.757 169.846V162.308H167.244V169.846H182.321V154.821H167.244V147.282H159.757V154.821H152.219V177.385H167.244V169.846H159.757Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 230H122.167V177.333H69.5V230ZM114.628 184.923V222.513H77.0387V184.923H114.628Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.217 177.385H137.191V184.923H152.217V177.385Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.425 177.385H204.887V184.923H212.425V177.385Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.757 184.872H152.219V192.41H159.757V184.872Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.652 214.975H137.191V222.513H144.678V199.949H152.216V192.41H129.652V214.975Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.476 192.41H234.938V199.949H242.476V192.41Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.013 222.513H227.449V230H257.5V199.949H250.013V222.513Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.091 192.41H84.5273V214.975H107.091V192.41Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.757 199.949H152.219V214.975H159.757V199.949Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.807 207.436H174.781V214.975H182.32V222.513H189.807V207.436Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.475 207.436H227.449V214.975H242.475V207.436Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.296 214.975H159.758V222.513H167.296V214.975Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.886 214.975H197.348V222.513H204.886V214.975Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.269 222.513H144.73V230.052H152.269V222.513Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.781 222.513H167.242V230.052H174.781V222.513Z",
    fill: "#C0C0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.347 222.513H189.809V230.052H197.347V222.513Z",
    fill: "#C0C0CF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1258_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.757 42H152.219V49.5386H159.757V42Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.883 42V94.6152H257.55V42H204.883ZM250.011 87.0766H212.422V49.487H250.011V87.0766Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.091 57.0254H84.5273V79.5895H107.091V57.0254Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.474 57.0254H219.91V79.5895H242.474V57.0254Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.319 87.1283H189.806V94.6668H197.345V79.5897H189.806V72.1027H197.345V57.0255H189.806V42H182.319V57.0255H174.781V72.1027H167.242V57.0255H152.216V64.5641H144.678V57.0255H152.216V49.5386H137.191V42H129.652V64.5641H137.191V79.5897H182.319V87.1283Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.167 42H69.5V94.6152H122.167V42ZM77.0387 87.0766V49.487H114.628V87.0766H77.0387Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.269 87.1282H144.73V94.6668H152.269V87.1282Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.296 87.1282H159.758V94.6668H167.296V87.1282Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.783 102.154H159.758V109.692H182.322V87.1282H174.783V102.154Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.757 94.667H152.219V102.206H159.757V94.667Z",
    fill: "#212134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.191 109.692H152.216V102.154H137.191V79.5896H129.652V117.179H137.191V109.692Z",
    fill: "#212134"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1258_6426)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 94.375,
    x2: 277.5,
    y2: 94.375,
    stroke: "#FFB01D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1258_6426",
    x: 41.2967,
    y: 12.4527,
    width: 41.3075,
    height: 37.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.96066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13388
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.113725 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_6426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_6426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1258_6426",
    x: 41.2967,
    y: 232.272,
    width: 41.3075,
    height: 37.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.96066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13388
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.113725 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_6426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_6426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1258_6426",
    x: 244.4,
    y: 232.272,
    width: 41.3075,
    height: 37.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.96066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13388
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.113725 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_6426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_6426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1258_6426",
    x: 243.466,
    y: 12.4527,
    width: 41.3075,
    height: 37.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.96066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13388
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.113725 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_6426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_6426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1258_6426",
    x: 39.2322,
    y: 89.0679,
    width: 248.536,
    height: 20.5355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.96066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13388
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.113725 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_6426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_6426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_6426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 135,
    fill: "white",
    transform: "translate(69.5 95)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1258_6426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 53,
    fill: "white",
    transform: "translate(69.5 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScanFigure);
export default __webpack_public_path__ + "static/media/qrScanFigure.e353edf4128a051daaf7561e6fb1b6a1.svg";
export { ForwardRef as ReactComponent };